import React, { useState, useRef, useEffect } from 'react';
import './Signup.css';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

function AuthForm() {
  const { user, signInWithGoogle, signOut } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    await signInWithGoogle();
  };

  const handleSignOut = async () => {
    await signOut();
    setShowDropdown(false);
    navigate('/');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (user) {
    // Get user's initials
    const fullName = user.user_metadata?.full_name || user.email || '';
    const names = fullName.split(' ');
    const initials = names.length >= 2 ? names[0][0] + names[1][0] : names[0]?.[0] || 'U';
    
    return (
      <div className="user-menu" ref={dropdownRef}>
        <div 
          className="user-icon"
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {initials.toUpperCase()}
        </div>
        {showDropdown && (
          <div className="user-dropdown">
            <button 
              className="logout-button"
              onClick={handleSignOut}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="AuthForm">
      <button onClick={handleGoogleSignIn} id="sign-in">
        Sign In
      </button>
      <button onClick={handleGoogleSignIn} id="sign-up">
        Sign Up for Free
      </button>
    </div>
  );
}

export default AuthForm;